import { Heading } from '@efdigital/ll-addon-ui';
import SharedResourcesList from '@efdigital/ll-xceed-v2/components/coaching/shared-resources-list.gts';
import type { CoachingCoacheeCohortResourcesModel } from '@efdigital/ll-xceed-v2/routes/coaching/coachee/cohort/resources';
import { PAGE_WRAPPER } from '@efdigital/ll-xceed-v2/utils/layout';
import type { TOC } from '@ember/component/template-only';
import { pageTitle } from 'ember-page-title';

interface CoachingCoacheeCohortResourcesSignature {
  Args: {
    model: CoachingCoacheeCohortResourcesModel;
    controller: unknown;
  };
}

<template>
  {{pageTitle "Resources"}}

  <div class={{PAGE_WRAPPER}}>
    <Heading
      @size="lg"
      @text="Resources"
      @secondary="Resources your coach has sent you."
      @class="mb-4"
    />

    <SharedResourcesList @items={{@model.items}} @role="coachee" />
  </div>
</template> satisfies TOC<CoachingCoacheeCohortResourcesSignature>;
